import io from 'socket.io-client';
import Api from "../../../../lib/api";

let singleton = Symbol();
let singletonEnforcer = Symbol();

class SocketService {
    constructor(enforcer) {
        if (enforcer !== singletonEnforcer)
            throw "Instantiation failed: use ServiceLocator.getInstance() instead of new.";

        this._socket = null;
    }

    static get instance() {
        if (!this[singleton])
            this[singleton] = new SocketService(singletonEnforcer);
        return this[singleton];
    }

    static set instance(v) { throw "Can't change constant property!" }

    connect() {
        if (this._socket) {
            return;
        }

        this._socket = io(Api.lmsUrl, {
            query: { requester: 'lms' },
            reconnection: true,
            reconnectionDelay: Math.floor(Math.random() * 2000) + 500,
            reconnectionDelayMax: 5000,
        });
    }

    disconnect() {
        if (this._socket) {
            this._socket.disconnect();
            this._socket = null;
        }
    }

    emit(eventName, data) {
        if (!this._socket) {
            return;
        }

        this._socket.emit(eventName, data);
    }

    on(eventName, callback) {
        if (!this._socket) {
            return;
        }

        this._socket.on(eventName, callback);
    }

    off(eventName, callback) {
        if (!this._socket) {
            return;
        }

        this._socket.off(eventName, callback);
    }
}

export default SocketService;